import { useCallback } from "react";

const useWsGameProfileHandler = ({
  setGameProfile,
  triggerInstantFeedback,
  triggerLevelUpAnimation,
  triggerAchievementUnlocked,
}) => {
  return useCallback((data) => {
    if (data.type !== "game_profile_update") return false;

    console.log("🎮 检查payload结构:", {
      hasPayload: !!data.payload,
      payloadType: typeof data.payload,
      payloadKeys: data.payload ? Object.keys(data.payload) : "null",
    });

    try {
      let payload = data.payload;
      if (typeof payload === "string") {
        console.log("🎮 payload是字符串，需要解析");
        payload = JSON.parse(payload);
      }

      const { profile, delta } = payload;
      console.log("🎮 解构结果:", {
        hasProfile: !!profile,
        hasDelta: !!delta,
        deltaType: typeof delta,
      });

      if (profile) {
        setGameProfile(profile);
        console.log("🎮 更新游戏Profile:", profile);
      }

      if (delta) {
        console.log("🎮 处理Delta数据:", delta);

        if (delta.xpGained > 0 || (delta.skillChanges && Object.keys(delta.skillChanges).length > 0)) {
          console.log("🎮 满足即时反馈条件，触发动画");
          triggerInstantFeedback(delta);
        } else {
          console.log("🎮 不满足即时反馈条件:", {
            xpGained: delta.xpGained,
            skillChangesCount: delta.skillChanges ? Object.keys(delta.skillChanges).length : 0,
          });
        }

        if (delta.leveledUp && delta.newLevel) {
          console.log("🎮 满足升级条件，触发升级动画:", delta.newLevel);
          triggerLevelUpAnimation(delta.newLevel);
        } else {
          console.log("🎮 不满足升级条件:", {
            leveledUp: delta.leveledUp,
            newLevel: delta.newLevel,
          });
        }

        if (delta.newAchievements && delta.newAchievements.length > 0) {
          console.log("🎮 满足成就解锁条件，触发成就动画:", delta.newAchievements);
          triggerAchievementUnlocked(delta.newAchievements);
        } else {
          console.log("🎮 不满足成就解锁条件:", {
            newAchievements: delta.newAchievements,
          });
        }
      }
    } catch (error) {
      console.error("🎮 处理游戏化更新时出错:", error);
    }

    return true;
  }, [
    setGameProfile,
    triggerAchievementUnlocked,
    triggerInstantFeedback,
    triggerLevelUpAnimation,
  ]);
};

export default useWsGameProfileHandler;
